<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap fixed">
      <v-col cols="12" class="icon-title word-type pb-5"
        ><icon-my-folder :width="24" :height="24" />설문지</v-col
      >
    </v-row>

    <!-- 목록 -->
    <survey-list class="overflow-y-auto" :searchReqGubun="tabGubun.tab1" />
  </div>
</template>

<script>
import SurveyList from '@/components/allDoc/SurveyList.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';

export default {
  data: () => ({
    tab: null,
    tabGubun: {
      tab1: 'MYDOC', // 내문서
      //tab2: 'TEMP', // 임시저장문서
    },
  }),
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_NAV
      }px`;
    },
  },
  mounted() {
    this.$store.commit('ELA/RESET_ELA_STATE');
  },
  components: {
    SurveyList,
    IconMyFolder,
  },
};
</script>

<style></style>
